import Vue from 'vue';

import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import '@/plugins/bootstrap-vue';
import '@/plugins/font-awesome';
import '@/plugins/keyboard-shortcuts';
import '@/plugins/sentry';
import '@/plugins/vee-validate';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
